/**
 * This function is passed as a parameter into an XAxis object.
 * This function will then be called on every single XAxis index (in our case this will be date)
 * It will then generate a custom Div per each index
 *  - on every first tick, we generate an line opening
 *  - on every second tick, we output a text div with the date corresponding with the shift grouping
 *  - on every third tick, we generate a closing line
 *
 * @param tick Complex Object that contains X, Y, and payload ( space between lines, date, index)
 */
export const DateTickEvery3rdTickWithVerticalDividersBar =
  ({
    fontWeight = "bold",
    fontSize = 10,
  }: {
    fontWeight?: string;
    fontSize?: number;
  }) =>
  props => {
    const { x, y, payload } = props;
    const { index, value, offset } = payload;
    const isSecondTick = index % 3 === 1;
    const isThirdTick = index % 3 === 0;

    if (isSecondTick) {
      return (
        <text
          x={x}
          y={y}
          textAnchor="middle"
          fontSize={fontSize}
          fontWeight={fontWeight}
        >
          {value}
        </text>
      );
    } else if (isThirdTick) {
      const pathX = Math.floor(x) - offset;
      return <path d={`M${pathX},${y - 4}v${-35}`} stroke="#666" />;
    } else {
      const pathX = Math.floor(x) + offset;
      return <path d={`M${pathX},${y - 4}v${-35}`} stroke="#666" />;
    }
  };

/**
 * This function is passed as a parameter into an XAxis object.
 * This function will then be called on every single XAxis index (in our case this will be date)
 * It will then generate a custom Div per each index
 *  - on every first tick, we generate an line opening
 *  - on every second tick, we output a text div with the date corresponding with the shift grouping
 *
 * @param tick Complex Object that contains X, Y, and payload ( space between lines, date, index)
 */
export const DateTickEvery2ndTickWithVerticalDividersBar =
  ({
    fontWeight = "bold",
    fontSize = 10,
  }: {
    fontWeight?: string;
    fontSize?: number;
  }) =>
  props => {
    const { x, y, payload } = props;
    const { index, value, offset } = payload;
    const isSecondTick = index % 2 === 0;

    if (isSecondTick) {
      const pathX = Math.floor(x) - offset;
      return <path d={`M${pathX},${y - 4}v${-35}`} stroke="#666" />;
    } else {
      return (
        <text
          x={x - offset}
          y={y}
          textAnchor="middle"
          fontSize={fontSize}
          fontWeight={fontWeight}
        >
          {value}
        </text>
      );
    }
  };
